import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useContent } from "../context/ContentContext";

export default function PortfolioPage() {
  const content = useContent();
  const clients = content.getPortfolio() || [];

  const scrollRef = React.useRef(null);
  const [paused, setPaused] = React.useState(false);

  React.useEffect(() => {
    const ref = scrollRef.current;
    if (!ref || clients.length === 0) return;

    let scrollSpeed = 1; // pixels per frame
    let direction = 1; // 1 = right, -1 = left
    let animationFrame;

    const step = () => {
      if (!ref || paused) {
        animationFrame = requestAnimationFrame(step);
        return;
      }

      ref.scrollLeft += scrollSpeed * direction;

      // Reverse direction at boundaries
      if (ref.scrollLeft <= 0) direction = 1;
      else if (ref.scrollLeft >= ref.scrollWidth - ref.clientWidth) direction = -1;

      animationFrame = requestAnimationFrame(step);
    };

    animationFrame = requestAnimationFrame(step);

    return () => cancelAnimationFrame(animationFrame);
  }, [clients.length, paused]);

  return (
    <Box sx={{ py: 6, px: { xs: 2, sm: 4 }, bgcolor: "white" }}>
      <Typography
        variant="h4"
        sx={{ mb: 4, fontWeight: "bold", textAlign: "left", whiteSpace: "nowrap" }}
      >
        Our Customers
      </Typography>

      <Box sx={{ overflow: "hidden", width: "100%" }}>
        <Box
          ref={scrollRef}
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
          onTouchStart={() => setPaused(true)}
          onTouchEnd={() => setPaused(false)}
          sx={{
            display: "flex",
            gap: 4,
            py: 1,
            px: 2,
            overflowX: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            '&::-webkit-scrollbar': { display: 'none' },
            touchAction: "pan-y", // allows vertical scroll but prevents horizontal interference
          }}
        >
          {clients.map((client, index) => (
            <Paper
              key={index}
              elevation={0}
              sx={{
                minWidth: 120,
                maxWidth: 180,
                p: 2,
                textAlign: "center",
                bgcolor: "transparent",
                flex: "0 0 auto",
              }}
            >
              <img
                src={client.image}
                alt={client.title || client.name}
                style={{
                  maxWidth: "100%",
                  maxHeight: "60px",
                  objectFit: "contain",
                  display: "block",
                  margin: "0 auto",
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                  fontWeight: 500,
                  color: "text.secondary",
                  whiteSpace: "nowrap",
                }}
              >
                {client.title || client.name}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
